module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/BIOMEDICAL SCIENCES-92cf475db55d4ac667e8f4d98a67ec8b.png";